export const AdminPropertiesSkeleton = () => (
  <div className="admin-property-list" aria-hidden="true">
    {Array.from({ length: 4 }).map((_, index) => (
      <div className="admin-property-card admin-property-card--skeleton" key={index}>
        <span className="skeleton admin-property-card-media-skeleton" />
        <div className="admin-property-card-body skeleton-stack">
          <span className="skeleton title" />
          <span className="skeleton text" />
          <span className="skeleton short" />
        </div>
      </div>
    ))}
  </div>
);
